import * as React from "react";
import styled from "styled-components";
import { getLitbLangFn } from "utils/lang";

import { litbErrorPoster } from "utils/playground/banner";

export const ErrorPageWrap = styled.section`
	padding: 50px 50px 100px;

	img {
		width: 262px;
		margin: 34px auto;
		display: block;
	}
	p {
		text-align: center;
		font-size: 14px;
		line-height: 21px;
		color: #666;
		font-family: "Avenir-Roman,sans-serif";
	}
	a {
		text-decoration: none;
		background: #cb2127;
		width: 180px;
		height: 40px;
		display: block;
		margin: 20px auto;
		line-height: 40px;
		text-align: center;
		color: #fff;
		font-weight: 800;
		font-family: "Avenir-Heavy,sans-serif";
	}
`;
export default function ErrorPage() {
	return (
		<ErrorPageWrap>
			<img className={"error img"} src={litbErrorPoster()} alt="" />
			<p>{getLitbLangFn("ErrorMessage")}</p>
			<a href={"/"}>{getLitbLangFn("GoShopping")}</a>
		</ErrorPageWrap>
	);
}
